import { fromJS } from "immutable"

import { segue, replace } from "global-action-creators"
import urls, { documentTitleFromUrl } from "imports/desktopPaths"

import searchifyActionTypes from "shared/search/searchify/action-types"
import {
    clearSearchifySelections,
    configureSearchify,
    generateUniqueSearchifyId,
    initializeSearchifySlice,
    startSearchify,
} from "shared/search/searchify/action-creators"
import {
    hideChangedInListManuallyFilter,
    openFilterGroup,
    registerFilterableListView,
    unregisterFilterableListView,
} from "shared/search/action-creators"

export function segueToSearchify() {
    return (dispatch) => {
        dispatch(segue(urls.power_search))
    }
}

export function openSearchify() {
    return (dispatch) => {
        dispatch({ type: searchifyActionTypes.OPEN_SEARCHIFY_MODAL })
    }
}

export function closeSearchify() {
    return (dispatch) => {
        dispatch({ type: searchifyActionTypes.CLOSE_SEARCHIFY_MODAL })
    }
}

export function popSearchify() {
    return (dispatch, getState) => {
        const currentSize = getState().search.get("searchifyPathStack").size
        const currentFlvId = getState().search.get("searchifyPathStack").last().get("uniqueFlvId")
        const originURL = getState().search.get("searchifyOriginDetails").get("originURL")

        // Remove the current path from searchifyPathStack.
        dispatch({ type: searchifyActionTypes.SEARCHIFY_BACK_ONE_LAYER })

        // unregister the searchify FLV!
        dispatch(unregisterFilterableListView(currentFlvId))

        // if there's only one element left in the stack, it's about to popped off
        // and we need to return to our origin.
        if (currentSize === 1) {
            const isSearchifyOpen = getState().search.get("isSearchifyOpen")

            // if we're using the searchify modal, close it. Otherwise, replace the url
            isSearchifyOpen ? dispatch(closeSearchify()) : dispatch(replace(originURL))
        }
    }
}

export function storeSearchifyRouteDetails(uniqueFlvId, flv) {
    return {
        type: searchifyActionTypes.STORE_SEARCHIFY_ROUTE_DETAILS,
        details: { uniqueFlvId, flv },
    }
}

const getInitialOriginDetails = (config, state) => {
    const originURL = window.location.pathname

    const searchOriginQdt =
        config.searchifySubmitParams &&
        config.searchifySubmitParams.uniqueFlvId &&
        state.search.getIn(["filterableListViews", config.searchifySubmitParams.uniqueFlvId, "quorumDataType"])

    const configQdt = config.quorumDataType

    if (!config.searchifyHeaderName) {
        config.searchifyHeaderName = documentTitleFromUrl(originURL)
    }

    return fromJS({
        searchifyHeaderName: config.searchifyHeaderName,
        quorumDataType: searchOriginQdt || configQdt,
        originURL,
    })
}

export function advancedSearchify(config) {
    return (dispatch, getState) => {
        const searchifyPaths = getState().search.get("searchifyPathStack")
        const uniqueFlvId = generateUniqueSearchifyId(searchifyPaths)
        const enteringSearchify = !getState().search.get("searchifyOriginDetails")

        // set up the searchify filterable list view!
        dispatch(registerFilterableListView(uniqueFlvId))

        // if there are no origin details, we're just starting searchify!
        if (enteringSearchify) {
            dispatch({
                type: searchifyActionTypes.STORE_SEARCHIFY_ORIGIN_DETAILS,
                details: getInitialOriginDetails(config, getState()),
            })
        }

        dispatch(initializeSearchifySlice(uniqueFlvId))

        // // configure advanced searchify
        dispatch(configureSearchify(uniqueFlvId, config))

        // dispatch that we are starting searchify from this location
        dispatch(startSearchify(uniqueFlvId, { uniqueFlvId, flvComponent: config.searchifyFLV }))

        // set the staffer type filter group to be open if powersearch is from outbox staffer selection
        // need to manually clear selection cuz the staffer type is selected through searchifyInitialFilters
        if (
            config.searchifyHeaderName === "Outbox" &&
            config.searchifyQDT === DjangIO.app.models.QuorumDataType.staffer
        ) {
            dispatch(openFilterGroup(uniqueFlvId, "stafferTypeFilterGroup"))
            dispatch(clearSearchifySelections(uniqueFlvId))
        }

        // if there are no current searchify details, we're not currently in searchify!
        // Thus, we need to segue to searchify! We need to segue after starting Searchify, hence
        // why the if statements can't be consolidated.
        if (enteringSearchify) {
            if (config.shouldOpenSearchifyModal) {
                dispatch(openSearchify())
            } else {
                dispatch(segueToSearchify())
            }
        }
    }
}
